
  import { Vue, Component, Prop } from "vue-property-decorator";
  import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
  import { Tag } from "@/generated/graphql";
  import DropdownOption from "@/entities/DropdownOption";
  import InputPlaceholder from "@/components/skeletonPlaceholder/components/InputPlaceholder.vue";
  import GET_TAGS from "@/apollo/tag/GetTags.gql";


  @Component({
    components: {
      InputPlaceholder,
      DropdownFilter,
    },
    apollo: {
      tags: {
        query: GET_TAGS,
        update(data: { tag: Tag[] }) {
          const tags = data.tag;

          this.selectedTag = tags.filter(tag => tag.id === this.selectedTagId);
          return tags;
        },
      },
    },
  })
  export default class EmploymentTypeSelect extends Vue {
    @Prop({ required: true, type: Array }) value!: DropdownOption[];
    @Prop({ default: true, type: Boolean }) multiple!: boolean;
    @Prop({default: false, type: Boolean}) readonly invalid!: boolean;
    @Prop({ type: String, default: "" }) readonly getcontainerStyle?: string;

    tags: Tag[] = [];
    selectedTag: DropdownOption[] = [];

    get tagsLoaded(): boolean {
      return this.tags.length > 0;
    }
    
    handleInput(val: DropdownOption[]) {
      this.$emit("input", val);
    }
  }
